window.app = window.app || {};

window.app.banner = {
  elements: document.querySelectorAll('.mt-banner-carousel'),
  sliders: [],

  init: function () {
    const _this = this;
    if (_this.elements.length == 0) return;

    _this.elements.forEach(element => {
      const slider = new Swiper(element.querySelector('.swiper'), {
        autoHeight: element.classList.contains('mt-banner-carousel--static-text'),
        slidesPerView: 1,
        spaceBetween: 0,
        direction: 'horizontal',
        draggable: true,
        allowTouchMove: true,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
      });
      _this.sliders.push(slider);
    });
    
  },
};
window.app.banner.init();